import { usePathname, useSearchParams } from 'next/navigation';

/**
 * Hook to generate search params for a Subrite product purchase
 * @returns URL string for the Subrite checkout page for the specified product
 */

export function useCheckoutParams(onCheckoutUrl: string = '/auth-check') {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const subriteUrl = new URL(process.env.NEXT_PUBLIC_SUBRITE_URL || '');
  const onCheckoutCompletedUrl = new URL(onCheckoutUrl, process.env.NEXT_PUBLIC_NEXTAUTH_URL);
  let reference = searchParams.get('reference') ?? pathname;
  if (reference === '/') {
    reference = '/hjem';
  }
  subriteUrl.searchParams.append('reference', reference);
  onCheckoutCompletedUrl.searchParams.append('reference', reference);
  subriteUrl.searchParams.append(
    'onCheckoutCompletedUrl',
    searchParams.get('onCheckoutCompletedUrl') ?? onCheckoutCompletedUrl.toString(),
  );
  return subriteUrl.searchParams.toString();
}
